import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IMerchantHashRequest {
  merchantId: number;
}

async function createMerchantHash(data: IMerchantHashRequest): Promise<any> {
  try {
    const response = await axiosInstance.post(`/Merchant/CreateHash?merchantId=${data.merchantId}`);
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useCreateMerchantHash() {
  return useMutation<any, Error, IMerchantHashRequest>((variables) =>
    createMerchantHash(variables)
  );
}
